import React from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import MyTableContent from "../components/MyTableContent";
import { useTabState } from "../hooks/tabState";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import { useAppSelector } from "../../../hooks/useAppDispatch"; // Adjust path if needed
import { RootState } from "../../../redux/store"; // Adjust path if needed

const LOCALE = "modules_MyGiftTable_pages_MyProducts";

const MyProducts: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  // Use the translated "catalog" as the default value.
  const [lastCategory] = useTabState("lastCategory", t("catalog"));

  // Read stickyOffset from Redux
  const stickyOffset = useAppSelector(
    (state: RootState) => state.uiState.stickyOffset
  );

  const handleCatalogClick = () => {
    if (lastCategory === t("catalog")) {
      navigate("/my-table"); // Navigate to the MyTable homepage
    } else {
      navigate(`/my-table/products?category=${lastCategory}`); // Navigate to the last selected category
    }
  };

  return (
    <MainLayout
      content={
        <TabNavigation
          stickyOffset={stickyOffset} // Pass Redux value here
          tabs={[
            {
              label: lastCategory,
              onClick: handleCatalogClick,
              component: null,
              isActive: false,
            },
            {
              label: t("myProducts"),
              component: <MyTableContent />,
              isActive: true,
            },
          ]}
        />
      }
    />
  );
};

export default withTranslations(LOCALE)(MyProducts);
